import React, { forwardRef } from "react";
import "./index.css";
import "./JobListings/JobListings.css";
import JobListings from "./JobListings";
import { HEADER_SUBHEAD } from "./JobListings/utils/jobsConstants";

const ExploreSection = forwardRef((props, ref) => {
  return (
    <div
      ref={ref}
      className="exploreSectionWrap animated-section section"
      id="jobOpening"
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="exploreWrap aosAnim">
              <div className="jobsHeader">
                <h2 className="jobsTitle">
                  <span className="jobsTitleAccent">Explore</span>, Apply,
                  Succeed
                </h2>
                <p className="jobsSubhead">{HEADER_SUBHEAD}</p>
              </div>
              <JobListings />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default ExploreSection;
